import React from 'react'
import { HiOutlineTrash, HiOutlinePencilAlt, HiOutlineLightningBolt } from "react-icons/hi";
import { Card, Group, Table, Tooltip, ActionIcon, Text, Badge, Box as MantineBox } from '@mantine/core';
import { currencyFormat } from 'simple-currency-format';

const PlansTable = ({ items, onOpen, remove }) =>
{
  return (
    <Card shadow="md" p={0} radius="lg" withBorder mx="md" className='w-full overflow-hidden'>
      <Table.ScrollContainer minWidth={ 600 }>
        <Table verticalSpacing="md" highlightOnHover>
          <Table.Thead bg="gray.0">
            <Table.Tr>
              <Table.Th px="xl" py="md"><Text size="xs" fw={800} c="dimmed" className="tracking-widest uppercase">Nombre del Plan</Text></Table.Th>
              <Table.Th><Text size="xs" fw={800} c="dimmed" className="tracking-widest uppercase">Velocidad</Text></Table.Th>
              <Table.Th><Text size="xs" fw={800} c="dimmed" className="tracking-widest uppercase">Precio Mensual</Text></Table.Th>
              <Table.Th></Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            { items && items.map((item) => (
              <Table.Tr
                key={ item._id }
                className="hover:bg-slate-50 transition-colors duration-200"
                style={{ borderLeft: '4px solid transparent' }}
                onMouseEnter={(e) => e.currentTarget.style.borderLeft = '4px solid var(--mantine-color-yellow-filled)'}
                onMouseLeave={(e) => e.currentTarget.style.borderLeft = '4px solid transparent'}
              >
                <Table.Td px="xl">
                  <MantineBox>
                    <Text fw={700} size="sm">{ item.name }</Text>
                    <Text size="xs" c="dimmed" className="truncate max-w-[200px]">{ item?.description || 'Sin descripción' }</Text>
                  </MantineBox>
                </Table.Td>
                
                <Table.Td>
                  <Group gap="xs">
                    <HiOutlineLightningBolt className="text-yellow-600" size={16} />
                    <Badge variant="light" color="yellow" radius="sm" size="lg">
                      { item?.megas || 0 } MB
                    </Badge>
                  </Group>
                </Table.Td>

                <Table.Td>
                  <Text fw={700} size="md" className="font-mono">
                    { currencyFormat(item.price || 0, 'es-MX', 'MXN', 2) }
                  </Text>
                </Table.Td>

                <Table.Td px="xl">
                  <Group gap="xs" justify="flex-end">
                    <Tooltip label='Editar plan' fontSize='xs' radius="md" withArrow>
                      <ActionIcon size="lg" onClick={ () => onOpen(item) } variant="light">
                        <HiOutlinePencilAlt size={18} />
                      </ActionIcon>
                    </Tooltip>
                    
                    <Tooltip label='Borrar Plan' fontSize='xs' radius="md" withArrow>
                      <ActionIcon size="lg" onClick={ () => remove({ _id: item._id }) } variant="subtle" color="red">
                        <HiOutlineTrash size={18} />
                      </ActionIcon>
                    </Tooltip>
                  </Group>
                </Table.Td>
              </Table.Tr>
            )) }
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Card>

  )
}

export default PlansTable
